export default __webpack_public_path__ + "static/media/citation-cancel.d09be2e4.svg";